@if (!isEmergency) {
  <div class="form-group">
    <!-- <label
    class="custom-input custom-input--checkbox custom-input--categories"
    *ngFor="let item of items; let i = index;">
    <input
      type="checkbox"
      [checked]="item.checked"
      [name]="uniqueControlName"
      [value]="item?.answer"
      (change)="checkNonEmergencySelect(i)">
      <span class="custom-input__indi"></span>
      <span class="custom-input__label">
        <span>{{item?.answer}}
          <a *ngIf="item?.showPopover" class="popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
            data-trigger="focus" data-html="true" data-placement="bottom"
            data-content="<div class=&quot;popover__content&quot;>Tooltip content can go over here. Tooltip content can go over here.</div>"
            data-original-title="" title="">
            <svg class="icon icon--sm">
              <use xlink:href="#help-Icon"></use>
            </svg>
          </a>
        </span>
        <img *ngIf="item?.image_url" [src]="item?.image_url" class="icon" alt="">
        <span class="custom-input__class" *ngIf="item?.info_comment">
          <svg class="icon">
            <use xlink:href="#info-small"></use>
          </svg>
          <span>{{item?.info_comment}}</span>
        </span>
      </span>
    </label> -->
    @for (item of items; track item; let i = $index) {
      <label class="tile">
        <input
          type="checkbox"
          [checked]="item.checked"
          [disabled]="readOnly"
          [name]="uniqueControlName"
          [value]="item?.answer"
          (change)="checkNonEmergencySelect(i)">
          <div class="tile__inner">
            <div class="tile__main">
              <div class="tile__content">
                <div class="tile__indi"><span></span></div>
                <div class="tile__label">
                  <div class="tile__title">{{item?.answer}}</div>
                  <div class="tile__subtitle">{{item?.info_comment}}</div>
                </div>
              </div>
              <div class="tile__right">
                @if (item?.showPopover) {
                  <a class="popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                    data-trigger="focus" data-html="true" data-placement="bottom"
                    data-content="<div class=&quot;popover__content&quot;>Tooltip content can go over here. Tooltip content can go over here.</div>"
                    data-original-title="" title="">
                    <svg class="icon icon--sm">
                      <use xlink:href="#help-Icon"></use>
                    </svg>
                  </a>
                }
                @if (item?.image_url) {
                  <img [src]="item?.image_url" class="icon icon--lg-xl" alt="">
                }
              </div>
            </div>
          </div>
        </label>
      }
    </div>
  }

  @if (isEmergency) {
    <div class="form-group">
      @for (item of items; track item; let i = $index) {
        <label
          class="custom-input custom-input--checkbox custom-input--categories custom-input--categories-claims-cancel"
          (click)="emitOpenModal(item?.checked ? 'Cancel' : 'Request', item)">
          <input
            type="checkbox"
            class="checkbox-item"
            [checked]="item?.checked"
            [disabled]="readOnly"
            [(ngModel)]="item.checked"
            [name]="uniqueControlName"
            [value]="item?.answer">
            <span class="custom-input__indi"></span>
            <span class="custom-input__label">
              <span>{{item?.answer}}</span>
              @if (item?.image_url) {
                <img [src]="item?.image_url" class="icon" alt="">
              }
              <span class="tag-pill tag-pill--requested">Requested</span>
            </span>
          </label>
        }
      </div>
    }
